module.exports = __webpack_public_path__ + "a9e1295e5a8ab8422ba10f42834e1975.png";